/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
/**
 * Create the mode and color classes for the component based on the classes passed in
 */
function createColorClasses(color) {
  return (typeof color === 'string' && color.length > 0) ? {
    'lar-color': true,
    [`lar-color-${color}`]: true
  } : undefined;
}
/**
 * Larva app selector wheret to append dynamic components
 */
function getAppRoot(doc) {
  return doc.querySelector('lar-app') || doc.body;
}

export { createColorClasses as c, getAppRoot as g };

//# sourceMappingURL=theme-d6db8abf.js.map